import { TextBox } from "./textBox";
import { ToggleButton } from "./toggleButton";
import { Helper } from "../util/helper";
import { ComponentHelper } from "../util/componentHelper";
import { NotificationHelper } from "../util/notificationHelper";
import { createHtppServiceInstance, HTTPService } from "../util/httpManager";
import { BusyIndicator } from "../../statistics/reactcomponent";
import { Config } from "../config/config";
import { EntityMachine } from "../../machine/machine";
import { EntityContact } from "../../contact/contact";
import { EntityAddress } from "../../address/address";
import { Context, Entity } from "./commonApp";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";
interface BaseDataTreeStructureState {
    showContacts: boolean;
    showMachines: boolean;
    filterValue: string;
    isLoading: boolean;
}

export default class BaseDataTreeStructure extends React.Component<BaseDataTreeStructureProps, BaseDataTreeStructureState>{
    private icuh = Helper;
    private storageSaveId = "BaseDataTreeStructure_State";
    private treeData = [];
    private dataUrl: string;
    private treeElementRef: any;
    private treeRef: kendo.ui.TreeView;
    private error = false;
    private template = "<span data-item-link data-item-url='#=item.appUrl#' class='span #=item.highlight==true?'highlight':''#'>#if(item.type==1){# <i class='fal fa-fw fa-home'></i> #} else if (item.type == 2) {# <i class='fal fa-fw fa-id-badge'></i> #} else if (item.type == 3) {# <i class='fal fa-fw fa-cogs'></i> #}##if(item.type==1){##=item.values.adrnr# | #=item.values.adrname# #} else if (item.type == 2) {##=item.values.ansprechpartner#, #=item.values.vorname# #} else if (item.type == 3) {##=item.values.maschnr# | #=item.values.maschbezeichnung# | #=item.values.maschtyp# #}#</span>";
    private timeoutHandle;
    private doUpdate = true;
    private translations: StringKeyDictionary<string> = null;
    private rootNode: HTMLDivElement;

    constructor(props) {
        super(props);

        // JQuery um contains für case insensitive erweitern
        $.extend(($ as any).expr[':'], {
            'containsi': function (element, i, match, array) {
                return (element.textContent || element.innerText || '').toLowerCase().indexOf((match[3] || "").toLowerCase()) >= 0;
            }
        });

        const storageObj = this.icuh.loadDataFromStorage(this.storageSaveId);
        this.initURL();
        this.state = { showContacts: storageObj !== undefined ? storageObj.showContacts : true, showMachines: storageObj !== undefined ? storageObj.showMachines : true, filterValue: "", isLoading: true };
    }

    private initURL = () => {
        let type: Number = 0;
        let keyVal: any;
        if (this.props.context.contextType == "address") {
            type = 1;
            keyVal = (this.props.entity as EntityAddress).AdrNr;
        }
        else if (this.props.context.contextType == "contact") {
            type = 2;
            keyVal = (this.props.entity as EntityContact).Pos;
        }
        if (this.props.context.contextType == "machine") {
            keyVal = (this.props.entity as EntityMachine).MaschNr;
            type = 3;
        }

        this.dataUrl = "BaseDataTreeStructure/GetTree?type=" + type + "&id=" + encodeURIComponent(keyVal);
    }

    componentDidMount() {
        Helper.getTranslations(["Adresse.Ansprechpartner", "Navigation.Maschinen"]).then(result => {
            this.translations = result.Data;
            this.setState({});
        });

        this.getTreeData();

        $(this.treeElementRef).on("mouseup", "span[data-item-link]", (e) => {
            if (e.target.attributes.getNamedItem("data-item-url") !== null) {
                let url = e.target.attributes.getNamedItem("data-item-url").value;

                //if (e.button === 0) { // left mousebutton
                //    url = this._icuh.addUrlParameter(url, "isWindow=true");
                //    //General.Sheet.Manager.getTopMostVisibleSheet().hide(() => {
                //    const sheet = General.Sheet.Manager.createSheetWithUrl(url);
                //    General.Functions.HistoryState.pushStateWithSheet(sheet, url);
                //    //});
                //}
                //else if (e.button === 1) { // middle mousebutton
                this.icuh.openInNewBrowserTab(url);
                //}
            }
            e.preventDefault();
            e.stopPropagation();
        });
    }

    componentDidUpdate(prevProps, prevState) {
        let storageObj = {
            showContacts: this.state.showContacts, showMachines: this.state.showMachines
        };
        this.icuh.saveDataToStorage(this.storageSaveId, storageObj, false);
        if (this.state.isLoading != prevState.isLoading) {
            kendo.ui.progress($(this.rootNode), this.state.isLoading);
        }
        if (this.doUpdate) {
            this.doUpdate = false;

            const updateFunc = () => {
                this.treeRef.setDataSource(this.buildDataSource());

                let that = this;
                if (this.state.filterValue !== "") {
                    $(this.treeElementRef).find(".k-group .k-group .k-in").closest("li").hide();
                    $(this.treeElementRef).find(".k-group").closest("li").hide();
                    $(this.treeElementRef).find(".span:containsi(" + this.state.filterValue + ")").each(function () {
                        $(this).parents("ul, li").each(function () {
                            that.treeRef.expand($(this).parents("li"));
                            $(this).show();
                        });
                    });
                    $(this.treeElementRef).find(".k-group .span:containsi(" + this.state.filterValue + ")").each(function () {
                        $(this).parents("ul, li").each(function () {
                            $(this).show();
                        });
                    });
                }
                else {
                    $(this.treeElementRef).find(".k-group").find("li").show();
                    var nodes = $(this.treeElementRef).find("> .k-group > li");

                    $.each(nodes, function (i, val) {
                        if (nodes[i].getAttribute("data-expanded") == null) {
                            $(nodes[i]).find("li").hide();
                        }
                    });
                }
            }

            if (this.icuh.hasValue(this.treeRef)) {
                updateFunc();
            } else {
                const handle = setInterval(() => {
                    if (this.icuh.hasValue(this.treeRef)) {
                        clearInterval(handle);
                        updateFunc();
                    }
                }, 10);
            }
        }
    }
    handleBeginDataLoad = () => {
        this.setState({ isLoading: true });
    }
    handleFinishedDataLoad = () => {
        this.setState({ isLoading: false });//  forceBusyIndicator: false 
    }
    componentWillUnmount() {
        if (this.icuh.hasValue(this.treeRef))
            this.treeRef.destroy();
    }

    private getTreeData() {
        this.handleBeginDataLoad();
        createHtppServiceInstance()
            .noBusyIndicator()
            .get(this.dataUrl)
            .then(result => {

                if (!result.error) {
                    this.treeData = result.Data;
                } else {
                    this.error = true;
                    NotificationHelper.showErrorMessage(result.message);
                }
                this.handleFinishedDataLoad();
                if (!this.error) {
                    this.treeRef = $(this.treeElementRef).kendoTreeView({
                        dataSource: this.buildDataSource(),
                        template: this.props.template || this.template
                    }).data("kendoTreeView");
                }
            });
    }

    private buildDataSource = () => {
        let filter = [];
        filter.push({ field: "type", operator: "eq", value: 1 });
        if (this.state.showContacts)
            filter.push({ field: "type", operator: "eq", value: 2 });
        if (this.state.showMachines)
            filter.push({ field: "type", operator: "eq", value: 3 });

        return new kendo.data.HierarchicalDataSource({
            data: this.treeData,
            filter: {
                logic: "or",
                filters: filter
            }
        });
    }

    private toggleMachines = (value: boolean) => {
        this.doUpdate = true;
        this.setState({ showMachines: value });
    }

    private toggleContacts = (value: boolean) => {
        this.doUpdate = true;
        this.setState({ showContacts: value });
    }

    private handleTextChange = (field, value) => {
        this.setState({ filterValue: value });

        clearTimeout(this.timeoutHandle);

        this.timeoutHandle = setTimeout(() => {
            this.doUpdate = true;
            this.setState({ filterValue: value });
        }, 500);
    }

    render() {
        let textBoxProps = ComponentHelper.createFactory().getDefaultTextBoxProps();
        textBoxProps.onChange = this.handleTextChange;
        textBoxProps.field.triggerOnChange = true;
        textBoxProps.field.faIconName = "search";
        let baseUrlObj = { "INNO_BASE_PATH": Config.baseUrl };
        let busyIndicator = null;
        if (this.state.isLoading === true) {
            busyIndicator = <BusyIndicator contextVariables={baseUrlObj} />;
        }
        return (
            <div ref={(e) => this.rootNode = e} className="flex-container">

                <div style={{ marginTop: "5px", marginBottom: "5px", marginLeft: "5px", display: "inline-flex", alignItems: "center" }}>
                    <ToggleButton initialValue={this.state.showContacts} handleToggle={this.toggleContacts} iconName={"id-badge"} title={this.translations == null ? "" : this.translations["Adresse.Ansprechpartner"]}></ToggleButton>
                    <ToggleButton initialValue={this.state.showMachines} handleToggle={this.toggleMachines} iconName={"cogs"} title={this.translations == null ? "" : this.translations["Navigation.Maschinen"]}></ToggleButton>
                    <div style={{ width: "200px", display: "inline-block", marginLeft: "5px" }}>
                        <TextBox {...textBoxProps} value={this.state.filterValue}></TextBox>
                    </div>
                </div>
                {busyIndicator}
                <div className="baseDataTreeStructureLayout flex-container__item" ref={(r) => this.treeElementRef = r} />
            </div >
        );
    }
}

interface BaseDataTreeStructureProps {
    context: Context;
    entity: Entity;
    template?: string;
}